<template>
  <b-sidebar
    id="sidebar-right"
    z-index="51001"
    title="Edit question"
    right
    shadow
    :visible="prompt"
    backdrop
    no-header
    sidebar-class="sidebar-lg"
    header-class="header-dark"
    bg-variant="white"
    width="420px"
    @change="(val) => (prompt = val)"
    @hidden="clearForm"
  >
    <!-- @hidden="clearForm" -->
    <!--<template #footer="{ hide }">
      <div class="d-flex header-dark text-light align-items-center px-3 py-2">
        <strong class="mr-auto">Footer</strong>
        <b-button size="sm" @click="hide">Close</b-button>
      </div>
    </template>-->

    <template #default="{ hide }" v-if="action">
      <!-- Header -->
      <div
        class="header-dark d-flex justify-content-between align-items-center content-sidebar-header px-4 py-3"
      >
        <!--  <b-button size="sm" variant="outline-success rounded-lg">
          {{ "Completed" }}
        </b-button> -->

        <feather-icon
          :icon="actionStyling[action._type].icon"
          class="p-2 inline-flex rounded-lg bg-white border border-warning shadow-sm"
          svgClasses="h-5 w-5"
        />

        <h5 class="mb-0">Manage action</h5>
        <div>
          <feather-icon
            icon="TrashIcon"
            class="cursor-pointer mr-2"
            svgClasses="h-5 w-5 stroke-2"
            @click="confirmDelete"
          />
          <!--<feather-icon
            class="ml-3 cursor-pointer"
            icon="InfoIcon"
            svgClasses="h-5 w-5 stroke-2"
            
          />-->
          <feather-icon
            class="ml-3 cursor-pointer"
            icon="XIcon"
            svgClasses="h-5 w-5 stroke-2"
            @click="hide"
          />
        </div>
      </div>

      <div class="px-4">
        <!-- Form start -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <label class="mt-4 form-label">Action type</label>
            <vs-select
              v-model="action._type"
              class="w-full"
              placeholder="No action"
            >
              <vs-select-item
                :key="index"
                :value="item.type"
                :text="item.description"
                v-for="(item, index) in actionTypes"
              />
            </vs-select>
            <vs-divider />
            <component
              :id="action.id"
              v-bind:is="'New' + action._type"
              :action="action"
              ref="customFields"
            />
            <vs-divider />
            <label class="form-label mt-2">Run action after</label>

            <div class="vx-col">
              <vs-input
                class="w-full"
                :placeholder="delayDescription"
                v-on:input="delayChange"
                v-model="delayUserDescription"
              />
              <p class="p-1">This action runs after {{ delayDescription }}</p>
              <!--<vs-input-number v-model="delay" />-->
            </div>

            <label class="form-label">Run only</label>

            <conditions :conditions="action.conditions" ref="conditions" />
            <vs-divider />
            <vs-row class="flex flex-wrap items-center">
              <vs-button
                class="mr-5 rounded-lg"
                color="warning"
                @click="
                  accept();
                  hide();
                "
                >Save</vs-button
              >
              <vs-button class="rounded-lg" color="primary" @click="hide"
                >Cancel</vs-button
              >
            </vs-row>
          </div>
        </div>
        <!-- Form end -->
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { mapGetters } from "vuex";
import NewSendMailAction from "./NewSendMailAction.vue";
import NewSendSmsAction from "./NewSendSmsAction.vue";
import NewAddPointsAction from "./NewAddPointsAction.vue";
import NewCreateNightpayVoucherAction from "./NewCreateNightpayVoucherAction.vue";
import NewAddLabelAction from "./NewAddLabelAction.vue";

import parse from "parse-duration";
import humanizeDuration from "humanize-duration";
import Conditions from "./Conditions/Conditions.vue";

export default {
  components: {
    NewSendMailAction,
    NewSendSmsAction,
    NewAddLabelAction,
    NewAddPointsAction,
    NewCreateNightpayVoucherAction,
    Conditions,
  },
  data() {
    return {
      parse,
      humanizeDuration,
      delayUserDescription: "",
      prompt: false,
      action: null,
      isNew: false,
    };
  },
  emits: ["update", "delete", "add"],
  computed: {
    ...mapGetters({
      actionTypes: "automations/actionTypes",
      actionStyling: "automations/actionStyling",
      iconMap: "lists/iconMap",
    }),
    delayDescription() {
      return this.humanizeDuration(this.action.delay);
    },
  },
  methods: {
    delayChange() {
      this.action.delay = this.parse(this.delayUserDescription);
    },
    confirmDelete() {
      if (this.isNew) {
        this.prompt = false;
        return;
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Delete?",
        accept: this.delete,
      });
    },
    show(action, isNew) {
      this.action = JSON.parse(JSON.stringify(action));
      this.isNew = isNew;
      this.prompt = true;
      this.delayUserDescription = this.humanizeDuration(this.action.delay);
    },
    async delete() {
      this.$emit("delete", this.action.id);
      this.prompt = false;
      this.clearForm();
    },
    async accept() {
      const action = {
        id: this.action.id,
        delay: parseInt(this.action.delay),
        _type: this.action._type,
        conditions: this.$refs.conditions.render(),
        ...this.$refs.customFields.render(),
      };

      if (this.isNew) {
        console.log("creating", action);
        this.$emit("add", action);
        //await this.$store.dispatch("automations/createAction", dto);
      } else {
        console.log("Updating", action);
        this.$emit("update", action);
        //await this.$store.dispatch("automations/updateAction", dto);
      }
      this.clearForm();
      this.prompt = false;
    },
    close() {},
    clearForm() {
      console.log("Clear form");
      this.action = null;
    },
  },
  async mounted() {},
};
</script>


<style scoped lang="css" src="bootstrap/dist/css/bootstrap.min.css"></style>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-vue/2.22.0/bootstrap-vue.min.css";

.header-dark {
  background-color: #f6f6f6;
}
.form-label {
  color: #5e5873;
  font-size: 0.857rem;
}
</style>
